import { Model } from '@/models/Model';
export class Template extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Template';
        this.$endpoint = '/templates';
        this.$fillable = ['value', 'file', 'is_default'];
    }
    subject(subject) {
        if (typeof subject !== 'string') {
            subject = subject.id || '';
        }
        this.$endpoint = '/subjects/' + subject + '/relationships/templates';
        return this;
    }
    subjectTemplate(subject) {
        if (typeof subject !== 'string') {
            subject = subject.id || '';
        }
        this.$endpoint = `/subjects/${subject}/relationships/templates/${this.id}`;
        return this;
    }
    projectTemplate(project) {
        if (typeof project !== 'string') {
            project = project.id || '';
        }
        this.$endpoint = `/projects/${project}/relationships/templates/${this.id}`;
        return this;
    }
    project(project) {
        if (!(project && project.id)) {
            throw new Error('To set project endpoint, an id is required in the model');
        }
        this.$endpoint = `/projects/${project.id}/relationships/templates`;
        return this;
    }
}
